import { z } from 'zod';
import { PatPermissionKeySchema } from '../permissions/catalogue.js';
// Personal access token (user_api_keys) self-service writes — the human
// programmatic credential (ADR-004). A PAT is the user acting as
// themselves: read-only at foundation, pinned to exactly one project, carrying a
// picked subset of the user's read permissions. Effective authority is always
// re-intersected live with the owner's real permissions in the pinned project per
// request — this schema only bounds what may be OFFERED at mint.
//
// Lifecycle is create / rename / revoke only (ADR-004 — no rotation machinery, and
// permissions + project + expiry are FROZEN at creation; a different shape is a new
// token). So there is a create body, a label-only rename body, and nothing else.
// The finite-expiry menu (ADR-004). The server computes `expires_at` from the
// choice — the client never sends a timestamp. `never` = no expiry (explicit,
// kept: an air-gapped NOC's Power BI refresh that silently dies is worse than a
// deliberate non-expiring token; the finite default lives in the UI).
export const PAT_EXPIRY_CHOICES = ['30d', '90d', '1y', 'never'];
export const PatExpiryChoiceSchema = z.enum(PAT_EXPIRY_CHOICES);
export const CreatePatRequestSchema = z
    .object({
    label: z.string().trim().min(1).max(64),
    // The pinned project — exactly one, always (PATs get no fleet analog; a
    // multi-project consumer mints one token per project). Validated to exist +
    // the caller must be a member (service-side); the wire only bounds length.
    project_id: z.string().max(16),
    // A non-empty subset of the read tier (PatPermissionKeySchema rejects any
    // write / manage / platform / machine key as a 400). At least one — a
    // zero-permission token authenticates but can read almost nothing, a footgun.
    permissions: z.array(PatPermissionKeySchema).min(1),
    expires_in: PatExpiryChoiceSchema,
})
    .strict();
// Rename — the only mutable field (label is cosmetic; it changes nothing the
// credential can do). Permissions / project / expiry are immutable by design.
export const RenamePatRequestSchema = z
    .object({ label: z.string().trim().min(1).max(64) })
    .strict();
